import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class NurseService {

  constructor(private http: HttpClient) { }

  createNurse(payload: any) {
    return this.http.post(`${environment.apiUrl}/nurse/create`, payload);
  }

  getPagedNurses(payload: {
    pageIndex: number;
    pageSize: number;
    filters: any;
    sortField?: string;
    sortOrder?: number;
  }) {
    const requestPayload = {
      ...payload,
    };
    return this.http.post(
      `${environment.apiUrl}/nurse/get-paged`,requestPayload
    );
  }

  updateNurse(payload: any) {
    return this.http.put(`${environment.apiUrl}/nurse/update`, payload);
  }

  getOneNurseById(id: string) {
    return this.http.get(`${environment.apiUrl}/nurse/get-one/${id}`);
  }

  getAllNurses() {
    return this.http.get(`${environment.apiUrl}/nurse/get-all`);
  }

  changePassword(payload: { id: string; oldPassword: string; password: string }) {
    return this.http.post(`${environment.apiUrl}/nurse/change-password`, payload);
  }

  getNurseCasualId(){
    return this.http.get(`${environment.apiUrl}/nurse/get-casual-id`)
  }

  syncCasualIds() {
    return this.http.post(`${environment.apiUrl}/nurse/sync-casual-ids`, {});
  }

  getNurseAttendance(startDate: string, endDate: string) {
    return this.http.post(`${environment.apiUrl}/nurse/attendance`, {
      startDate,
      endDate
    });
  }

  permanentConversion(nurseId: string, action: 'Approve' | 'Pending' | 'Reject') {
    return this.http.post(`${environment.apiUrl}/nurse/${nurseId}/permanent-conversion`, {
      action,
    });
  }
}
